import React from 'react';

export const Acast = () => (
  <svg viewBox="0 0 13 12" focusable="false" role="presentation">
    <path
      fill="#ffffff"
      d="M6.5 0c3.925 0 5.74 1.856 5.786 3.605l-4.844 6.652-.008.013c-.562.902-2.069 1.608-3.432 1.608C1.572 11.878 0 10.75 0 9.005 0 6.866 2.392 5.72 7.108 5.598l.21-.007V3.517c0-.453 0-1.212-.908-1.212-.82 0-.882.554-.882.725 0 .145.032.271.06.381.027.102.052.197.052.308 0 .72-.87 1.183-2.218 1.183-1.508 0-2.374-.706-2.374-1.94C1.048 1.489 2.922 0 6.501 0zm.817 8.383V6.755l-.23.016c-1.48.107-2.006.912-2.006 1.634 0 .652.424 1.057 1.108 1.057.623 0 1.128-.483 1.128-1.08z"
    ></path>
  </svg>
);
export const Facebook = () => (
  <svg
    aria-hidden="true"
    width="1em"
    height="1em"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 264 512"
  >
    <path
      fill="currentColor"
      d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"
    ></path>
  </svg>
);
export const ApplePodcasts = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <defs>
      <linearGradient id="a">
        <stop offset="0" stopColor="#822cbe" />
        <stop offset="1" stopColor="#d772fb" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="458.9"
        x2="456.36"
        y1="303.81"
        xlinkHref="#a"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-309.21)"
      />
    </defs>
    <rect width="300" height="300" fill="url(#b)" ry="66.74" />
    <path
      fill="#fff"
      d="M140.84 262.64c-8.95-3.2-10.87-7.55-14.54-33.04-4.27-29.63-5.2-47.97-2.73-53.78 3.28-7.7 12.18-12.07 24.63-12.12 12.35-.05 21.33 4.36 24.63 12.12 2.48 5.8 1.55 24.15-2.72 53.78-2.9 20.7-4.5 25.93-8.5 29.45-5.5 4.87-13.3 6.22-20.7 3.6zm-38.23-30.4c-30.9-15.2-50.7-40.92-57.9-75.14-1.8-8.83-2.1-29.9-.4-38 4.5-21.75 13.1-38.76 27.4-53.8 20.6-21.72 47.1-33.2 76.6-33.2 29.2 0 55.6 11.27 75.7 32.34 15.3 15.9 23.9 32.73 28.3 54.9 1.5 7.38 1.5 27.5.1 35.8-4.6 26.24-19.2 50.14-40.5 66.2-7.6 5.74-26.2 15.76-29.2 15.76-1.1 0-1.2-1.14-.7-5.75.9-7.4 1.8-8.94 6-10.7 6.7-2.8 18.1-10.92 25.1-17.94 12.1-12 21-27.7 25.1-44.2 2.6-10.3 2.3-33.2-.6-43.8-9.1-33.7-36.6-59.9-70.3-66.9-9.8-2-27.6-2-37.5 0-34.1 7-62.3 34.5-70.9 69.1-2.3 9.4-2.3 32.3 0 41.7 5.7 22.9 20.5 43.9 39.9 56.4 3.8 2.5 8.4 5.1 10.3 5.9 4.2 1.8 5.1 3.3 5.9 10.7.5 4.5.4 5.8-.7 5.8-.7 0-5.8-2.2-11.2-4.8zm.4-40.68c-10.4-8.3-19.6-23.02-23.4-37.46-2.3-8.72-2.3-25.3.1-34 6.3-23.48 23.6-41.68 47.6-50.23 8.2-2.9 26.4-3.55 36.5-1.32 34.8 7.75 59.5 42.6 54.7 77.17-1.9 13.93-6.7 25.37-15.2 36-4.2 5.37-14.4 14.38-16.2 14.38-.3 0-.6-3.4-.6-7.54V181l5.2-6.2c19.6-23.48 18.2-56.28-3.2-77.8-8.3-8.38-17.9-13.3-30.3-15.57-8-1.48-9.7-1.48-18.1-.1-12.75 2.08-22.63 7.02-31.4 15.7-21.5 21.3-22.9 54.27-3.3 77.77l5.16 6.2v7.6c0 4.2-.33 7.6-.74 7.6-.4 0-3.3-2-6.4-4.5zm34.7-40.83c-8.9-4.14-13.7-11.95-13.8-22.13 0-9.15 5.1-17.13 13.9-21.8 5.6-2.94 15.5-2.94 21.1.02 6.1 3.17 11.1 9.32 13 15.74 5.8 19.72-15.1 37-34 28.17z"
    />
    <circle cx="149.89" cy="129.67" r="24.94" fill="#fff" />
    <path
      fill="#fff"
      d="M152.28 164.27c1.73.23 5.17.68 8.35 1.7 3.2 1 6.1 2.57 8.36 4.18 2.2 1.6 3.8 3.26 4.8 5.28 1 2.02 1.5 4.42 1.8 8.35.2 3.94.2 9.4-.7 19.6-.9 10.17-2.7 25.08-4.1 34.63-1.4 9.6-2.4 13.8-3.7 16.9-1.3 3.2-3 5.3-4.9 6.8-1.9 1.5-4.1 2.4-6.2 2.9-2.1.5-4 .5-5.8.5-1.8 0-3.5 0-5.8-.5s-5.3-1.4-7.5-3.2c-2.3-1.8-3.8-4.4-5-7.8-1.2-3.4-2.1-7.5-3.3-15.7-1.2-8.2-2.8-20.4-3.8-29.7s-1.4-15.7-1.48-20c-.1-4.3.1-6.43.6-8.5.5-2 1.3-3.9 2.4-5.5 1.1-1.6 2.54-3 4-4.1 1.43-1.1 2.9-1.9 4.66-2.52 1.74-.7 3.83-1.3 6.4-1.8 2.6-.5 5.6-1 7.14-1.2 1.54-.23 1.54-.23 3.26 0z"
    />
  </svg>
);
export const OverCast = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
    <defs />
    <path
      fill="#fc7e0f"
      fillRule="evenodd"
      d="M400 800a400 400 0 11400-400 399 399 0 01-400 400zm0-158.33l30-30-30-115-30 115zM361.67 640l-15 56.67 35-35zm76.66 0l-20 20 35 35zm28.34 103.33L400 676.67l-66.67 66.66C355 746.67 376.67 750 400 750s45-1.67 66.67-6.67zM400 50C206.67 50 50 206.67 50 400c0 153.33 98.33 283.33 235 330l75-278.33C343.33 440 333.33 420 333.33 398.33a66.67 66.67 0 01133.34 0c0 21.67-10 40-26.67 53.34L515 730c136.67-46.67 235-176.67 235-330 0-193.33-156.67-350-350-350zm228.33 523.33c-8.33 10-23.33 13.34-35 5S580 555 588.33 545c0 0 45-60 45-145s-45-145-45-145c-8.33-10-6.66-25 5-33.33s26.67-5 35 5c3.34 3.33 55 71.66 55 173.33s-51.66 170-55 173.33zm-121.66-65c-10-10-8.34-28.33 1.66-38.33 0 0 25-26.67 25-70s-25-68.33-25-70c-10-10-10-26.67-1.66-38.33 10-11.67 25-11.67 35-1.67 1.66 1.67 41.66 43.33 41.66 110s-40 108.33-41.66 110c-10 10-25 8.33-35-1.67zm-213.34 0c-10 10-25 11.67-35 1.67-1.66-3.33-41.66-43.33-41.66-110s40-106.67 41.66-110c10-10 26.67-10 35 1.67 10 10 8.34 28.33-1.66 38.33 0 1.67-25 26.67-25 70s25 70 25 70a28.22 28.22 0 011.66 38.33zm-86.66 70c-11.67 8.34-26.67 5-35-5-3.34-3.33-55-71.66-55-173.33s51.66-170 55-173.33c8.33-10 23.33-13.34 35-5S220 245 211.67 255c0 0-45 60-45 145s45 145 45 145c8.33 10 5 25-5 33.33z"
    />
  </svg>
);
export const PocketCasts = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 222 222">
    <defs />
    <g fill="none" fillRule="evenodd">
      <path fill="#F43E37" d="M221.5 110.7a110.7 110.7 0 11-221.5 0 110.7 110.7 0 01221.5 0z" />
      <path
        fill="#FFF"
        d="M24.6 110.7a86.1 86.1 0 11172.3 0h-21.6a64.6 64.6 0 10-64.6 64.6V197a86.1 86.1 0 01-86-86.2zm86.1 51.7a51.7 51.7 0 1151.7-51.7h-18.8a32.9 32.9 0 10-32.9 33v18.7z"
      />
    </g>
  </svg>
);
export const RadioPublicRedFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 74 80"
  >
    <defs>
      <polygon id="flag-red-a" points="63.574 69.531 63.574 8.575 26.987 8.575 26.987 69.531" />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(5 5)">
      <path
        fill="#CE262F"
        d="M63.5742084,67.8671356 C51.3788164,62.1045932 39.1834244,73.629678 26.9868422,67.8671356 L26.9868422,10.2381525 C39.1822343,16.0006949 51.3776263,4.47561017 63.5742084,10.2381525 L63.5742084,67.8671356"
      />
      <path
        fill="#FFF"
        d="M43.7854681,36.9628475 C44.2079688,36.8655593 44.6292793,36.7658983 45.0517799,36.6662373 C46.6227682,36.2948814 46.7727262,35.3030169 46.7751065,34.1403051 L46.7751065,27.8770847 C46.7751065,26.5150508 46.6239584,25.6881017 45.0517799,26.0594576 C44.6292793,26.1591186 44.2079688,26.2587797 43.7854681,26.3560678 L43.7854681,36.9628475 Z M43.7854681,43.0742034 L43.7854681,58.1253898 C41.5396689,58.6450508 39.2938696,59.1172542 37.0468803,59.3248814 L37.0468803,21.7479322 C40.2388429,21.4525085 43.4308056,20.6231864 46.6227682,19.881661 C52.3473545,18.5599661 53.5613001,21.4750508 53.5636803,26.0653898 L53.5636803,33.5909831 C53.5648705,38.2596271 51.6915859,41.2281017 46.9774308,42.3255593 C45.9134432,42.5699661 44.8494557,42.8274237 43.7854681,43.0742034 L43.7854681,43.0742034 Z"
      />
      <path
        fill="#992326"
        d="M37.0832986,59.3578644 C37.0832986,59.3578644 36.5167907,62.5600678 26.9861282,67.8670169 L26.9861282,36.7336271 L37.0832986,59.3578644 Z"
      />
      <path
        fill="#CE262F"
        d="M37.0496176,59.2926102 C24.699507,53.5300678 12.3505866,65.0551525 0.000476057073,59.2926102 L0.000476057073,1.66362712 C12.3505866,7.42616949 24.699507,-4.09891525 37.0496176,1.66362712 L37.0496176,59.2926102 Z"
      />
      <path
        fill="#FFF"
        d="M16.9354923,27.2940678 C17.3746549,27.1944068 17.8138176,27.0911864 18.2529802,26.9891525 C19.619264,26.6688136 20.1286451,26.0494915 20.1262648,24.2816949 L20.1262648,19.1811864 C20.1274549,17.5652542 19.8239685,17.1274576 18.4553045,17.4466102 C17.9483037,17.5652542 17.442493,17.6838983 16.9354923,17.7989831 L16.9354923,27.2940678 M16.9354923,49.5671186 C14.689693,50.079661 12.4438938,50.5435593 10.1969044,50.75 L10.1969044,13.1730508 C13.7435296,12.8467797 17.2901548,11.8810169 20.83678,11.0920339 C24.9415821,10.1630508 27.0160007,12.2915254 27.0171909,16.320678 L27.0171909,22.33 C27.0195712,25.4527119 25.2950544,26.9867797 24.0287426,27.7757627 C25.0927302,27.9798305 26.918409,29.0440678 26.9160288,31.8345763 L26.9160288,44.6125424 C26.9160288,46.2284746 27.2171349,46.9094915 27.4730155,47.3461017 L27.4730155,47.5988136 C25.2272163,47.7566102 22.9814171,48.189661 20.7356178,48.6915254 C20.3821455,48.3652542 20.1274549,47.6154237 20.1262648,45.949661 L20.1262648,34.989322 C20.1238845,33.2238983 19.7216163,32.8584746 18.3541423,33.1776271 C17.8816557,33.2879661 17.4079789,33.3983051 16.9354923,33.5062712 L16.9354923,49.5671186"
      />
    </g>
  </svg>
);
export const Downcast = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style={{ enableBackground: 'new 0 0 100 100' }}
    xmlSpace="preserve"
  >
    <rect
      x="5.5"
      y="5.5"
      display="none"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#C80000"
      width="89.1"
      height="89.1"
    />
    <rect
      x="20"
      y="20"
      display="none"
      fillRule="evenodd"
      clipRule="evenodd"
      width="60"
      height="60"
    />
    <g id="Layer_3">
      <circle fillRule="evenodd" clipRule="evenodd" fill="#E10000" cx="50" cy="50" r="49" />
    </g>
    <g id="Layer_2"></g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FFFFFF"
      d="M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M50,96.3C24.4,96.3,3.7,75.6,3.7,50
			C3.7,24.4,24.4,3.7,50,3.7S96.3,24.4,96.3,50C96.3,75.6,75.6,96.3,50,96.3z"
    />
    <g id="D__x26__Waves_2_">
      <g>
        <path
          id="Large_Wave_7_"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M82.2,50.8c0,3.3-0.7,7.4-1.8,11.5c-0.8,2.9-1.9,5.5-3.2,8.2c-2,4.1-4.7,7.8-7.9,11.1
					c-0.2,0.2-0.4,0.4-0.6,0.6c-0.5,0.4-1,0.4-1.5-0.1c-1.1-1.1-2.2-2.2-3.4-3.3c-0.5-0.5-1-1-1.5-1.4c-0.6-0.5-0.6-1.1,0-1.6
					c1.8-1.8,3.4-3.8,4.8-6c1.4-2.2,2.5-4.5,3.4-6.9c1-2.8,1.8-5.6,2.1-8.5C73.4,49.2,73,44,71.4,39c-1.6-5.1-4.2-9.7-7.8-13.7
					c-0.4-0.4-0.8-0.8-1.1-1.2c-0.2-0.3-0.4-0.6-0.3-0.9c0.1-0.2,0.2-0.4,0.4-0.6c1.5-1.4,3.1-3.1,4.9-4.7c0.6-0.5,1.1-0.5,1.7,0
					c1,1,2,2.1,3,3.3c4.8,6,7.8,12.8,9.3,20.2C82,44.2,82.2,47,82.2,50.8z"
        />
        <path
          id="Small_Wave_7_"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M63,50c0,4.5-1.1,8.9-3.1,13.1c-1.3,2.8-3.1,5.4-5.3,7.6c-0.1,0.1-0.1,0.1-0.2,0.2
					c-0.5,0.5-1,0.5-1.5,0c-1.7-1.6-3.3-3.2-5-4.9c-0.4-0.4-0.5-0.9-0.1-1.4c0.6-0.7,1.2-1.4,1.8-2.1c2.2-3.1,3.5-6.5,4-10.2
					c0.4-2.9,0.2-5.7-0.7-8.5c-0.9-3.2-2.6-6-4.9-8.5c-0.6-0.6-0.5-1.1,0-1.7c1.6-1.5,3.2-3.1,4.8-4.6c0.1-0.1,0.2-0.2,0.3-0.2
					c0.5-0.3,0.9-0.3,1.3,0.1c0.8,0.7,1.5,1.6,2.1,2.4c2.7,3.4,4.4,7.3,5.5,11.4C62.7,45.1,63,47.5,63,50z"
        />
        <path
          id="D_7_"
          fill="#FFFFFF"
          d="M43.1,48.9c-0.1-1.7-0.4-3.4-1.1-5c-1.1-2.8-3-5-5.6-6.5c-2.2-1.3-4.7-1.8-7.2-1.8
					c-3.6,0-5.8,0-9.4,0c-0.6,0-0.8,0.2-0.8,0.9c0,4.5,0,9.2,0,13.7c0,4.5,0,9.8,0,14.2c0,0.4,0.2,0.6,0.7,0.6c3.4,0,5.2,0,8.6,0
					c1.6,0,3-0.3,4.4-0.6c4.5-1,7.7-3.6,9.3-7.8C43,54.1,43.3,51.5,43.1,48.9z M24.7,50.1c0-2.5,0-5.9,0-8.4c0-0.6,0.3-0.7,0.9-0.7
					c1.2,0,2.1,0,3.4,0c3.2,0,5.4,2.4,6.3,5.4c0.7,2.5,0.7,5.4-0.2,7.8c-0.7,1.7-1.8,3-3.5,3.7c-1,0.4-2,0.6-3,0.6c-1,0-2,0-2.9,0
					c-0.7,0-1-0.2-1-0.8L24.7,50.1z"
        />
      </g>
    </g>
  </svg>
);
export const Android = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="15pt"
    height="15pt"
    viewBox="0 0 15 15"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: 'none',
          fillRule: 'evenodd',
          fill: 'rgb(23.921569%,86.27451%,51.764706%)',
          fillOpacity: 1,
        }}
        d="M 1.238281 0 L 13.761719 0 C 14.445312 0 15 0.554688 15 1.238281 L 15 13.761719 C 15 14.445312 14.445312 15 13.761719 15 L 1.238281 15 C 0.554688 15 0 14.445312 0 13.761719 L 0 1.238281 C 0 0.554688 0.554688 0 1.238281 0 Z M 1.238281 0 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(100%,100%,100%)',
          fillOpacity: 1,
        }}
        d="M 10.425781 7.085938 C 10.136719 7.085938 9.902344 6.851562 9.902344 6.558594 C 9.902344 6.269531 10.136719 6.03125 10.425781 6.03125 C 10.71875 6.03125 10.953125 6.269531 10.953125 6.558594 C 10.953125 6.851562 10.71875 7.085938 10.425781 7.085938 M 4.609375 7.085938 C 4.320312 7.085938 4.085938 6.851562 4.085938 6.558594 C 4.085938 6.269531 4.320312 6.03125 4.609375 6.03125 C 4.902344 6.03125 5.136719 6.269531 5.136719 6.558594 C 5.136719 6.851562 4.902344 7.085938 4.609375 7.085938 M 10.617188 3.914062 L 11.667969 2.089844 C 11.707031 2.023438 11.707031 1.941406 11.667969 1.871094 C 11.628906 1.804688 11.554688 1.761719 11.476562 1.761719 C 11.398438 1.761719 11.328125 1.804688 11.289062 1.871094 L 10.222656 3.71875 C 9.410156 3.347656 8.496094 3.136719 7.519531 3.136719 C 6.542969 3.136719 5.628906 3.347656 4.8125 3.71875 L 3.75 1.871094 C 3.710938 1.804688 3.636719 1.761719 3.558594 1.761719 C 3.480469 1.761719 3.410156 1.804688 3.371094 1.871094 C 3.332031 1.941406 3.332031 2.023438 3.371094 2.089844 L 4.421875 3.914062 C 2.617188 4.898438 1.378906 6.726562 1.199219 8.886719 L 13.835938 8.886719 C 13.65625 6.726562 12.421875 4.898438 10.617188 3.914062 "
      />
    </g>
  </svg>
);
export const RssFeed = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-icon="rss"
    role="img"
    viewBox="0 0 19.743282 19.743328"
    version="1.1"
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="m 5.644502,16.921008 c 0,1.55871 -1.263569,2.82228 -2.822273,2.82228 C 1.263524,19.743288 0,18.479718 0,16.921008 c 0,-1.5587 1.263568,-2.82227 2.822273,-2.82227 1.558704,0 2.822229,1.26361 2.822229,2.82227 z m 7.741299,2.0823 C 13.017642,12.190118 7.560436,6.726038 0.739975,6.357478 0.337398,6.335708 0,6.659188 0,7.062338 v 2.11839 c 0,0.37084 0.286012,0.68185 0.656066,0.70591 4.928413,0.321 8.878873,4.26163 9.200538,9.20053 0.02411,0.37006 0.335107,0.65607 0.70591,0.65607 h 2.118391 c 0.403194,5e-5 0.726667,-0.33735 0.704896,-0.73993 z m 6.357023,0.0127 C 19.372902,8.711598 11.082009,0.37218801 0.727283,4.5800923e-4 0.329333,-0.01382199 0,0.30766801 0,0.70583801 V 2.824188 c 0,0.3801 0.301217,0.68947 0.68101,0.70507 8.425218,0.34547 15.187639,7.10916 15.533058,15.53306 0.01556,0.37979 0.324926,0.68101 0.705072,0.68101 h 2.118347 c 0.398126,-4e-5 0.719616,-0.32938 0.705337,-0.72733 z"
    />
  </svg>
);
export const Patreon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 19.679815 18.937979"
  >
    <path
      d="M3.47 0v18.938H0V0zm9.111 0a7.099 7.099 0 110 14.198 7.099 7.099 0 010-14.198z"
      fill="#141518"
    />
  </svg>
);
export const AcastPlus = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.83594 10.0283H14.3727V5.79492C14.3727 5.79492 13.3308 5.79492 12.0779 5.79492C10.5349 5.79492 9.84913 6.41477 9.84913 7.46982C9.84913 8.11605 9.83594 10.0283 9.83594 10.0283Z" />
    <path d="M5.60315 5.79492H1.06641V10.0283C1.06641 10.0283 2.10828 10.0283 3.36116 10.0283C4.90418 10.0283 5.58996 9.40849 5.58996 8.35343C5.58996 7.70721 5.60315 5.79492 5.60315 5.79492Z" />
    <path d="M9.83574 3.19722C9.83574 2.47187 9.83574 0.533203 9.83574 0.533203H7.46186C6.43318 0.533203 5.60233 1.36406 5.60233 2.39274C5.60233 2.39274 5.58913 7.70759 5.58913 8.35381C5.58913 8.97366 5.35175 9.44843 4.82422 9.72538C5.36494 9.46162 5.76058 9.02641 6.27492 8.52526C6.73651 8.06367 7.88389 6.85036 8.83344 5.9008C9.91487 4.81937 9.83574 3.92257 9.83574 3.19722Z" />
    <path d="M5.60285 12.6278C5.60285 13.3531 5.60285 15.2918 5.60285 15.2918H7.97673C9.00541 15.2918 9.83627 14.4609 9.83627 13.4323C9.83627 13.4323 9.84946 8.1174 9.84946 7.47118C9.84946 6.85134 10.0868 6.37656 10.6144 6.09961C10.0737 6.36337 9.67801 6.79858 9.16367 7.29973C8.70208 7.76132 7.5547 8.97464 6.60515 9.92419C5.52372 11.0056 5.60285 11.9156 5.60285 12.6278Z" />
  </svg>
);
export const Locker = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.5 15H21V13.0625C21 10.3125 18.75 8.03125 16 8C13.25 8 11 10.25 11 13V15H10.5C9.65625 15 9 15.6875 9 16.5V22.5C9 23.3438 9.65625 24 10.5 24H21.5C22.3125 24 23 23.3438 23 22.5V16.5C23 15.6875 22.3125 15 21.5 15ZM12 13C12 10.8125 13.7812 9 16 9C18.1875 9 20 10.8125 20 13V15H12V13ZM21.5 23H10.5C10.2188 23 10 22.7812 10 22.5V16.5C10 16.25 10.2188 16 10.5 16H21.5C21.75 16 22 16.25 22 16.5V22.5C22 22.7812 21.75 23 21.5 23Z"
      fill="black"
    />
  </svg>
);
export const SettingsGeneralSVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.05469 2.14453C7.02734 2.11719 6.97266 2.11719 6.91797 2.14453L1.72266 4.11328L7 6.19141L12.25 4.11328L7.05469 2.14453ZM1.3125 11.0859C1.3125 11.1953 1.36719 11.2773 1.44922 11.3047L6.34375 13.1641V7.33984L1.3125 5.37109V11.0859ZM7.65625 13.1641L12.5234 11.3047C12.6055 11.2773 12.6875 11.1953 12.6875 11.0859V5.37109L7.65625 7.33984V13.1641ZM6.45312 0.914062C6.78125 0.777344 7.19141 0.777344 7.51953 0.914062L12.9883 2.99219C13.5898 3.21094 14 3.78516 14 4.44141V11.0859C14 11.7422 13.5898 12.2891 12.9883 12.5352L7.51953 14.6133C7.19141 14.75 6.80859 14.75 6.45312 14.6133L0.984375 12.5352C0.382812 12.2891 0 11.7422 0 11.0859V4.44141C0 3.78516 0.382812 3.21094 0.984375 2.99219L6.45312 0.914062Z"
      fill="currentColor"
      fillOpacity="0.85"
    />
  </svg>
);
export const MarketplaceProfileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em">
    <path
      d="M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"
      fill="currentColor"
    />
  </svg>
);

export const SearchDollar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em">
    <path d="M505 442.7l-99.7-99.7c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6 .1-34zm-297-90.7c-79.5 0-144-64.3-144-144 0-79.5 64.4-144 144-144 79.5 0 144 64.3 144 144 0 79.5-64.4 144-144 144zm27.1-152.5l-45-13.5c-5.2-1.6-8.8-6.8-8.8-12.7 0-7.3 5.3-13.2 11.8-13.2h28.1c4.6 0 9 1.3 12.8 3.7 3.2 2 7.4 1.9 10.1-.7l11.8-11.2c3.5-3.4 3.3-9.2-.6-12.1-9.1-6.8-20.1-10.8-31.4-11.4V112c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16.1c-23.6 .6-42.7 20.6-42.7 45.1 0 20 13 37.8 31.6 43.4l45 13.5c5.2 1.6 8.8 6.8 8.8 12.7 0 7.3-5.3 13.2-11.8 13.2h-28.1c-4.6 0-9-1.3-12.8-3.7-3.2-2-7.4-1.9-10.1 .7l-11.8 11.2c-3.5 3.4-3.3 9.2 .6 12.1 9.1 6.8 20.1 10.8 31.4 11.4V304c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16.1c23.6-.6 42.7-20.5 42.7-45.1 0-20-13-37.8-31.6-43.4z" />
  </svg>
);

export const UsdCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em">
    <path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,22c-5.514,0-10-4.486-10-10S6.486,2,12,2s10,4.486,10,10-4.486,10-10,10Zm4-8c0,1.654-1.346,3-3,3v1c0,.553-.447,1-1,1s-1-.447-1-1v-1h-.268c-1.067,0-2.063-.574-2.598-1.499-.277-.479-.113-1.09,.364-1.366,.479-.279,1.091-.113,1.366,.364,.179,.31,.511,.501,.867,.501h2.268c.552,0,1-.448,1-1,0-.378-.271-.698-.644-.76l-3.041-.507c-1.342-.223-2.315-1.373-2.315-2.733,0-1.654,1.346-3,3-3v-1c0-.552,.447-1,1-1s1,.448,1,1v1h.268c1.067,0,2.063,.575,2.598,1.5,.277,.478,.113,1.089-.364,1.366-.48,.277-1.091,.113-1.366-.365-.179-.309-.511-.5-.867-.5h-2.268c-.552,0-1,.449-1,1,0,.378,.271,.698,.644,.76l3.041,.507c1.342,.223,2.315,1.373,2.315,2.733Z" />
  </svg>
);

export const AIIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      d="M9.75 8.375C9.79688 8.375 9.86719 8.42188 9.91406 8.49219L10.5 9.875L11.8828 10.4609C11.9531 10.5078 12 10.5781 12 10.625C12 10.6953 11.9531 10.7656 11.8828 10.8125L10.5 11.375L9.91406 12.7812C9.86719 12.8516 9.79688 12.8984 9.75 12.8984C9.67969 12.8984 9.60938 12.8516 9.5625 12.7812L9 11.375L7.59375 10.8125C7.52344 10.7656 7.47656 10.6953 7.47656 10.625C7.47656 10.5781 7.52344 10.5078 7.59375 10.4609L9 9.875L9.5625 8.49219C9.60938 8.42188 9.67969 8.375 9.75 8.375ZM3.98438 2.70312C4.17188 2.32812 4.80469 2.32812 4.99219 2.70312L6.21094 5.16406L8.67188 6.38281C8.85938 6.47656 8.97656 6.6875 9 6.875C8.97656 7.08594 8.85938 7.29688 8.67188 7.39062L6.21094 8.60938L4.99219 11.0703C4.89844 11.2578 4.6875 11.3984 4.5 11.3984C4.28906 11.3984 4.07812 11.2578 3.98438 11.0703L2.76562 8.60938L0.304688 7.39062C0.117188 7.29688 0 7.08594 0 6.875C0 6.6875 0.117188 6.47656 0.304688 6.38281L2.76562 5.16406L3.98438 2.70312ZM3.67969 5.82031C3.63281 5.91406 3.51562 6.03125 3.42188 6.07812L1.80469 6.875L3.42188 7.69531C3.51562 7.74219 3.63281 7.85938 3.67969 7.95312L4.5 9.57031L5.29688 7.95312C5.34375 7.85938 5.46094 7.74219 5.55469 7.69531L7.17188 6.875L5.55469 6.07812C5.46094 6.03125 5.34375 5.91406 5.29688 5.82031L4.5 4.20312L3.67969 5.82031ZM9.75 0.875C9.79688 0.875 9.86719 0.921875 9.91406 0.992188L10.5 2.375L11.8828 2.96094C11.9531 3.00781 12 3.07812 12 3.125C12 3.19531 11.9531 3.26562 11.8828 3.3125L10.5 3.875L9.91406 5.28125C9.86719 5.35156 9.79688 5.39844 9.75 5.39844C9.67969 5.39844 9.60938 5.35156 9.5625 5.28125L9 3.875L7.59375 3.3125C7.52344 3.26562 7.47656 3.19531 7.47656 3.125C7.47656 3.07812 7.52344 3.00781 7.59375 2.96094L9 2.375L9.5625 0.992188C9.60938 0.921875 9.67969 0.875 9.75 0.875Z"
      fill="#8C8CD4"
    />
  </svg>
);
